module.exports = __webpack_public_path__ + "FORD-logo.png";